import OWContainer from 'styles/styled-components/ow-container';
import { Spinner } from 'components/design';
import useController from '../controllers/edit-nested-product-category-controller';
import { NestedProductCategoryForm } from '../components/nested-product-categories-form';

export const EditNestedProductCategoryRoute = () => {
    const {
        formData,
        onChange,
        onSubmit,
        onCancel,
        dataChanged,
        isLoading,
        isEditProductCategoryLoading,
        errors,
        isUnlimited,
        handleCheckboxChange,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <NestedProductCategoryForm
                    formData={formData}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    onCheckChange={handleCheckboxChange}
                    isUnlimited={isUnlimited}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditProductCategoryLoading}
                    errors={errors}
                />
            )}
        </OWContainer>
    );
};
